import React from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@gcs/design-system/react";

import * as S from "./PQOSection.style";

const PQOSection = () => {
  const location = useLocation();

  const isBusinessHealthInsurance = location.pathname.includes(
    "/paraempresa/seguro-saude"
  );

  const currentHref = isBusinessHealthInsurance
    ? "/paraempresa/seguro-saude/resultados#results"
    : "/paravoce/seguro-saude/resultados#results";

  return (
    <S.PQOSectionContainer>
      <S.PQOSectionContent className="container">
        <S.PQOSectionHeader>
          <S.PQOSectionTitle>
            Programa de Qualificação de Operadoras - PQO
          </S.PQOSectionTitle>

          <S.PQOSectionDescription>
            Iniciativa desenvolvida pela Agência Nacional de Saúde Suplementar
            (ANS) para avalição anual do desempenho das operadoras de planos de
            saúde. Os resultados da avaliação das operadoras são traduzidos pelo
            Índice de Desempenho da Saúde Suplementar (IDSS). O IDSS é um índice
            composto por um conjunto de indicadores agrupados em quatro
            dimensões, que é calculado com base nos dados extraídos dos sistemas
            de informações da Agência ou coletados nos sistemas nacionais de
            informação em saúde.
          </S.PQOSectionDescription>
        </S.PQOSectionHeader>

        <Button as="a" href={currentHref} variant="secondary">
          Ver resultados
        </Button>
      </S.PQOSectionContent>
    </S.PQOSectionContainer>
  );
};

export default PQOSection;
